const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/assets/$assetId.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/assets/$assetId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { assetQuery } from '@/features/assets/services/assetQueries';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { logicalSegmentsQueryOptions } from '@/features/mcap/services/segmentQueries';
import { ProjectDetailSkeleton } from '@/features/raw-footage/components/ProjectDetailSkeleton';
import { videoSegmentsQuery } from '@/features/video/services/videoSegmentQueries';
import { createFileRoute } from '@tanstack/react-router';
type McapAsset = Extract<ProjectAsset, {
  mediaType: 'mcap';
}>;
type VideoAsset = Extract<ProjectAsset, {
  mediaType: 'video';
}>;

/**
 * Full-page asset detail (`/assets/$assetId`). It inherits the shared authenticated
 * boundary through the chromeless `_workspace` shell, so it has no app sidebar and
 * fills the viewport. The asset is the only required loader read.
 * Media-specific timeline data is prefetched after that read resolves, but the prefetches are
 * deliberately not awaited: navigation never waits on optional data, and failures stay local
 * rather than failing the route. Everything
 * playback-related — MCAP metadata and its playback lease, plus video transcode readiness
 * and the HLS manifest — is also read in-component for the same failure isolation.
 */
export const Route = createFileRoute('/_authenticated/_workspace/assets/$assetId')({
  beforeLoad: requireCapabilities(has => has('assets.read')),
  loader: async ({
    context: {
      queryClient
    },
    params: {
      assetId
    }
  }) => {
    const asset = await queryClient.ensureQueryData(assetQuery(assetId));
    if (asset?.mediaType === 'video') {
      void queryClient.prefetchQuery(videoSegmentsQuery(assetId));
    }
    if (asset?.mediaType === 'mcap') {
      void queryClient.prefetchQuery(logicalSegmentsQueryOptions(assetId));
    }
    return asset;
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: () => <div className="flex min-h-svh flex-col p-6">
      <ProjectDetailSkeleton />
    </div>,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});